
export class ToolHolderRebuildOption {
  constructor(
    public hash?: string,
    public rebuildToolHolderPublicHash?: string,
    public rebuildToolHolderPublicName?: string,
    public rebuildOrder?: number,
  ) { }

  clone() {
    return new ToolHolderRebuildOption (
      this.hash,
      this.rebuildToolHolderPublicHash,
      this.rebuildToolHolderPublicName,
      this.rebuildOrder
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-holder-rebuild-option.ts